/*
 * scroll-video.js — plays a background/content <video> when it scrolls into view,
 * pauses (and mutes) it when it scrolls out. Used by m-split-media and
 * m-heritage-stats when a bg_video_url is set with a scroll-triggered mode
 * (as opposed to m-hero / m-statement, which autoplay muted from page load).
 *
 * Markup contract (see m-split-media.liquid / m-heritage-stats.liquid):
 *   <video data-scroll-video [data-try-audio="true"]> ... </video>
 *   <button data-scroll-video-sound aria-pressed="false"> ... </button>  (optional, sibling)
 *
 * data-try-audio="true": on entering the viewport, attempts to play WITH sound.
 * Browsers usually block autoplay-with-sound before any user gesture on the page —
 * when that happens (play() rejects, or the try throws) we fall back to a muted
 * autoplay and surface the Sound button so the visitor can turn audio on manually.
 * Once the visitor has interacted with the page (any click/tap), subsequent
 * scroll-ins for data-try-audio videos are retried with sound.
 *
 * Everything else behaves like the sitewide hero pattern: muted autoplay while
 * in view + a manual Sound toggle, paused (and re-muted) on scroll-out.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var userInteracted = false;
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, function () { userInteracted = true; }, { once: true, passive: true });
  });

  function wireSoundButton(video, btn) {
    if (!btn) return;
    var iconOff = btn.querySelector('.m-hero__sound-icon--off, [data-sound-off]');
    var iconOn = btn.querySelector('.m-hero__sound-icon--on, [data-sound-on]');
    function reflect() {
      var on = !video.muted;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Turn video sound off' : 'Turn video sound on');
      if (iconOff) iconOff.style.display = on ? 'none' : '';
      if (iconOn) iconOn.style.display = on ? '' : 'none';
    }
    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) { video.play().catch(function () { video.muted = true; reflect(); }); }
      reflect();
    });
    reflect();
  }

  function tryPlayWithAudio(video) {
    video.muted = false;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  }

  function playMuted(video) {
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('[data-scroll-video]');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var wantsAudio = video.getAttribute('data-try-audio') === 'true';
          if (wantsAudio && userInteracted) {
            tryPlayWithAudio(video);
          } else {
            playMuted(video);
          }
        } else {
          video.pause();
          video.muted = true;
          var sec = video.closest('[data-scroll-video-wrap]');
          var btn = sec ? sec.querySelector('[data-scroll-video-sound]') : null;
          if (btn) {
            btn.setAttribute('aria-pressed', 'false');
            var iconOff = btn.querySelector('.m-hero__sound-icon--off, [data-sound-off]');
            var iconOn = btn.querySelector('.m-hero__sound-icon--on, [data-sound-on]');
            if (iconOff) iconOff.style.display = '';
            if (iconOn) iconOn.style.display = 'none';
          }
        }
      });
    }, { threshold: 0.45 });

    videos.forEach(function (video) {
      video.pause();
      video.muted = true;
      observer.observe(video);
      var sec = video.closest('[data-scroll-video-wrap]');
      var btn = sec ? sec.querySelector('[data-scroll-video-sound]') : null;
      wireSoundButton(video, btn);
    });
  });
})();
